import React from 'react';

import PropertyManagementTable from './property_management_table';
import ScheduleTable from './schedule_table';

export function RoyaltySettings() {
  return (
    <div className="d-flex flex-column gap-3">
      <ScheduleTable />
      <PropertyManagementTable />
    </div>
  );
}

export default RoyaltySettings;
